import nBossConnection from 'modules/base/service/nBossConnection';
import { Button } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function ExportMeasurementButton(props) {
    return (
        <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item || !props.item.id} href={`${nBossConnection.basePath}measurementTableControl/exportToXlsx?id=${props.item ? props.item.id : ''}`} component='a' startIcon={<ExitToAppIcon className='hidden sm:flex text-black' />}>
            <span className='text-black'>Export</span>
        </Button>
    );
}

export default ExportMeasurementButton;